<template>
  <div class="unmannedAerialVehicleDetail">
    <img :src="cueerntObj.detailImgOne" alt="">
    <img :src="cueerntObj.detailImgTwo" alt="">
    <img v-if="cueerntObj.detailImgThree" :src="cueerntObj.detailImgThree" alt="">
    <img v-if="cueerntObj.detailImgFour" :src="cueerntObj.detailImgFour" alt="">
  </div>
</template>

<script>
export default {
  data () {
    return {
      cueerntObj: {}
    }
  },
  created () {
    let detailList = JSON.parse(
      window.sessionStorage.getItem('unmannedAerialVehicleObj')
    )
    if (detailList.length > 0) {
      this.cueerntObj = detailList.find(item => {
        if (item.id == this.$route.query.id) {
          return item
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.unmannedAerialVehicleDetail {
  height: 100%;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
}
</style>
